module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-update/invoice-main-info/invoice-main-info.scss
// module id = ./web/modern/components/invoices/invoice-update/invoice-main-info/invoice-main-info.scss
// module chunks = 0